import { getFirestore, doc, collection, query, where, getDocs, deleteDoc } from 'firebase/firestore'
import { UserServiceAPI } from '@/helpers/service'
import { dateTomorrow } from '@/helpers/time'
import { useStreakStore } from '@/stores/streak'

export default class Streak {
  constructor(id, streak) {
    this.id = id
    this.streak = streak
    // this._types
  }

  static converter(object) {
    return new Streak(
      object.id,
      object.streak,
    )
  }

  get ref() {
    if (!this._ref) {
      this._ref = doc(getFirestore(), 'streaks', this.id).withConverter(Streak.firestoreConverter())
    }
    return this._ref
  }

  // get types() {
  //   if () {
  //   }
  //   return this._types
  // }

  // Saves the streak locally to the store.
  static save(result) {
    if (!result) {
      return null
    }

    // Attach name of day to streak array.
    result.streak.forEach((e) => {
      const d = new Date(e.date)
      e.day = d.dayName()
    })

    // Update streak store with latest.
    const store = useStreakStore()
    const object = Streak.converter(result)
    store.update(object)

    // Return resulting object.
    return object
  }

  static async create() {
    const apiService = new UserServiceAPI()
    const result = await apiService.createStreak(dateTomorrow())
    return Streak.save(result)
  }

  static async get(id) {
    const apiService = new UserServiceAPI()
    const result = await apiService.getStreak(id)
    if (!result) return null
    return Streak.save(result)
  }

  async deactivate() {
    const apiService = new UserServiceAPI()
    return await apiService.deactivateStreak(this.id)
  }

  async delete() {
    await deleteDoc(this.ref)
  }

  static firestoreConverter() {
    return {
      // TODO: Complete this When writing streaks to Firestore is required.
      // toFirestore: (streak) => {
      //   return {
      //     x: streak.x,
      //   }
      // },
      fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options)

        return new Streak(
          snapshot.id,
          data.streak,
        )
      }
    }
  }

  static collection() {
    return collection(getFirestore(), 'streaks').withConverter(Streak.firestoreConverter())
  }

  static async getByUser(uid) {
    const userRef = doc(getFirestore(), 'users', uid)
    const q = query(
      Streak.collection(),
      where('uuid', '==', userRef),
    )
    const snap = await getDocs(q)
    return snap.docs.map(doc => doc.data())
  }
}